import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import * as Glob from "../../Globale";
import { Sessione } from "../../components/";
import { _LanguagePicker } from "../layout";
import logo from "../images/logo_all_risks.png";

const useStyles = makeStyles(theme => ({
    footer: {
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(0.5, 2),
        position: "fixed",
        width: "100%",
        zIndex: theme.zIndex.appBar,
        bottom: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }
}));

export const _Footer: React.FC<Glob.IGlobaleProps> = props => {
    const classes = useStyles();

    return (
        <footer className={classes.footer}>
{/*            <img alt="Logo" src={logo} width="130" />*/}
            <Box display="none">
                <i>Session:</i> <Sessione {...props} />
            </Box>
            <_LanguagePicker {...props} />
        </footer>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/Footer.tsx